<template>
  <div class="party-manage">
    <div class="choose-state">
      <span
        v-for="(choose,index) in chooses"
        :key="choose.name"
        @click="active(index,choose.name)"
        :class="isClass==index?'choose':''"
      >{{choose.name}}</span>
    </div>

    <div class="content">
        <!-- 组织关系转接 -->
        <organ v-if="isClass==0?true:false"></organ>
        <!-- 党员缴费介绍 -->
        <div class="introduce" v-if="isClass==1?true:false">
            <img src="@/assets/partyhome/partyManage/dp-dy-df1.png" alt="">
        </div>
        <!-- 党员在线缴费 -->
        <money v-if="isClass==2?true:false"></money>
    </div>

  </div>
</template>

<script>
import organ from "../partyManage/_partyRelation"
import money from "../partyManage/_partyMoney"
export default {
  data() {
    return {
      chooses: [
        { name: "组织关系转接" },
        { name: "党费缴纳介绍" },
        { name: "党费在线缴纳" }
      ],
      isClass: 0
    };
  },
  methods:{
      active(index, name) {
      this.isClass = index;
    },
  },
  components:{
      organ,
      money
  }
};
</script>


<style lang="scss" scoped>
.party-manage {
    .content{
        .introduce{
            img{
                width: 100%;
            }
            text-align: center;

        }
        background: #fff;
    }
  .choose-state {
    .choose {
      color: #000;
      position: relative;
      &::before {
        position: absolute;
        width: 25%;
        height: 0.08rem;
        background: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%),
          linear-gradient(#ae1717, #ae1717);
        border-radius: 0.1rem;
        left: 37.5%;
        content: "";
        bottom: 0;
      }
    }
    span {
      display: inline-block;
      width: 33%;
      text-align: center;
      line-height: 3;
      color: #999999;
    }
    background: #fff;
    width: 100%;
    white-space: nowrap;
    overflow-x: scroll;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>


